import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-dropdown-button',
  templateUrl: './dropdown-button.component.html',
  styleUrls: ['./dropdown-button.component.css']
})
export class DropdownButtonComponent {

  @Output()
  public itemclick = new EventEmitter<number>();
  constructor() { }

  @Input()
  public dropDownItems = [];
}
